import { z } from 'zod';

export const getMWUserTypesSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    code: z.string(),
  })
);

export type GetMWUserTypes = z.infer<typeof getMWUserTypesSchema>;
